import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import StorageUtils from "@services/storage";
import { type StateKeys, stateTemplate } from "@services/storage/storeTemplate";
import type { RootState } from "../../../store";

// export const templateState = stateTemplate();
export const initialState = stateTemplate();

export const storeName = "state";

export interface Action {
	value: any;
	name?: StateKeys;
}

export const stateSlice = createSlice({
	name: storeName,
	initialState,
	reducers: {
		reset: (state, action: PayloadAction<Action>) => {
			// logger.debug(namespace + "->" + reset.name, "Reset state");
			return { ...initialState, ...action.payload.value };
		},

		hydrate: (state, action: PayloadAction<Action>) => {
			// logger.debug(namespace + "->" + hydrate.name, "Hydrating state");
			return { ...initialState, ...action.payload.value };
		},

		importing: (state, action: PayloadAction<Action>) => {
			// logger.debug(namespace + "->" + importing.name, "Importing state");
			return { ...state, ...action.payload.value };
		},

		save: (state) => {
			Object.entries(state).forEach(([key, value]) => {
				StorageUtils.saveToStorage({
					type: "local",
					store: storeName,
					key,
					value,
				});
			});
			// logger.debug(namespace + "->" + save.name, "Saving state");
		},

		resetSquareState: (state) => {
			// logger.debug(namespace + "->" + resetSquareState.name, "Resetting square state");
			return {
				...state,
				SquareCardCVVValid: false,
				SquareCardNumberValid: false,
				SquareExpirationValid: false,
			};
		},

		set: (state, action: PayloadAction<Action>) => {
			// logger.debug(namespace + "->" + set.name, `Setting state ${action.payload.name}`);
			if (action.payload.name) {
				state[action.payload.name] = action.payload.value as never;
			}
		},
		setMultiple: (state, action: PayloadAction<Action>) => {
			// logger.debug(namespace + "->" + setMultiple.name, "Setting multiple state");
			Object.entries(action.payload.value).forEach(([key, value]) => {
				StorageUtils.saveToStorage({
					type: "local",
					store: storeName,
					key,
					value,
				});
			});
			return { ...state, ...action.payload.value };
		},
	},
});

export const { actions, reducer } = stateSlice;
export const {
	reset,
	hydrate,
	save,
	set,
	importing,
	resetSquareState,
	setMultiple,
} = actions;

export const stateSelector = (state: RootState) => state.state;

export default reducer;
